<template>
  <div>
    EXPORT
  </div>
</template>

<style scoped lang="less">

</style>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import api from "../services/api";
import dayjs from 'dayjs';

export default {
  name: "home",
  data: function() {
    return {
      allUsers: [],
      filter: "taskers",
      search: ""
    };
  },
  methods: {
    getUserCountry(user) {
      const phoneNumber = user.phoneNumber || '';
      if (user.selectedArea && user.selectedArea.country) {
        return user.selectedArea.country;
      } else if (phoneNumber.startsWith('+370')) {
        return 'LT'
      } else if (phoneNumber.startsWith('+48')) {
        return 'PL'
      } else {
        return 'UNKNOWN';
      }
    }
  },
  created: async function() {
    this.allUsers = [];
    const users = await api.getAllUsers();
    const allUsers = users
      .filter(u => !u.fake && u.phoneNumber && u.email
        //&& u.createdAt._seconds > (new Date('2021 03 31')).getTime() / 1000
      )
      .map((u, i) => ({ ...u, index: i }))
      .sort((u1, u2) => {
        const t1 = (u1.createdAt || { _seconds: 0 })._seconds;
        const t2 = (u2.createdAt || { _seconds: 0 })._seconds;
        return t2 - t1;
      });
    let csvString = "ID;REGISTERED AT;COUNTRY;LANGUAGE;IS PRO;PRO TYPE;SERVICE AREA;EMAIL;PHONE;NAME;SURNAME;NUM ORDERS;COMPANY\n";
    allUsers.forEach(user => {
      const columns = [
        user.id,
        (new Date(user.createdAt._seconds * 1000)).toISOString(),
        this.getUserCountry(user),
        user.appLocale,
        user.verified,
        user.proType,
        user.serviceArea && user.serviceArea.country,
        user.email,
        user.phoneNumber,
        user.firstName,
        user.lastName,
        user.numOrders,
        user.company
      ];
      csvString += columns.join(';') + "\n";
    });
    const blob = new Blob([csvString]);
    const a = window.document.createElement("a");
    a.href = window.URL.createObjectURL(blob, {type: "text/plain"});
    a.download = `users-${dayjs().format('YYYY-MM-DD')}.csv`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
  // components: {
  //   HelloWorld
  // }
};
</script>
